import styled from 'styled-components';

const Container = styled.div`
  padding: 0 15px;
`;
const ProductCreateStep = styled.div`
  img {
    width: 100%;
  }
`;

export { Container, ProductCreateStep };
